import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null)

  const faqs = [
    {
      question: 'Dois-je obligatoirement acheter des Joy-Cons ?',
      answer: 'Non. L\'application est entièrement fonctionnelle pour la stimulation visuelle et auditive sans eux. Les Joy-Cons ajoutent simplement une dimension tactile supplémentaire pour une expérience encore plus complète. Vous pouvez commencer sans et décider plus tard si cette fonctionnalité vous intéresse.'
    },
    {
      question: 'Y a-t-il quelque chose à installer ?',
      answer: 'Non, rien à installer ! EMDR Plus est une application web qui fonctionne directement dans votre navigateur. Il vous suffit d\'avoir une version récente d\'un navigateur moderne comme Google Chrome ou Microsoft Edge. Même pour connecter les Joy-Cons, aucune installation n\'est nécessaire - tout se fait via Bluetooth.'
    },
    {
      question: 'Quels Joy-Cons sont compatibles ?',
      answer: (
        <div>
          Tous les Joy-Cons Nintendo Switch sont compatibles avec EMDR Plus ! Peu importe la couleur ou l'édition, ils fonctionnent tous parfaitement. 
          <br /><br />
          Vous pouvez les acheter où vous voulez, par exemple sur <a href="https://www.amazon.fr/Nintendo-Bluetooth-Manettes-Gauche-Violet/dp/B07VFTVVWX/ref=asc_df_B0C6YFL48Z?mcid=1428930f986d355abe9106a7c3ba257a&tag=googshopfr-21&linkCode=df0&hvadid=701439836575&hvpos=&hvnetw=g&hvrand=15487016743919864196&hvpone=&hvptwo=&hvqmt=&hvdev=c&hvdvcmdl=&hvlocint=&hvlocphy=9055885&hvtargid=pla-2249610914527&hvocijid=15487016743919864196-B0C6YFL48Z-&hvexpln=0&th=1" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700 underline">Amazon</a> (lien non sponsorisé).
          <br /><br />
          <strong>Important :</strong> Vous avez besoin d'une paire complète (Joy-Con gauche + Joy-Con droit) pour la stimulation bilatérale.
        </div>
      )
    },
    {
      question: 'Comment connecter mes Joy-Cons ?',
      answer: (
        <div>
          C'est très simple ! Il suffit d'activer le Bluetooth sur votre ordinateur et de connecter les Joy-Cons comme n'importe quel appareil Bluetooth.
          <br /><br />
          Pour un guide visuel complet, regardez cette <a href="https://youtu.be/lGnqYmDRAvs" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700 underline">vidéo explicative sur YouTube</a> qui montre toutes les étapes.
          <br /><br />
          Une fois connectés, EMDR Plus les détectera automatiquement et vous pourrez profiter de la stimulation tactile !
        </div>
      )
    },
    {
      question: 'Est-ce que l\'application stocke des données sur mes patients ?',
      answer: 'Non. EMDR Plus est un outil de stimulation, pas un logiciel de gestion de dossiers patients. Aucune donnée personnelle ou médicale n\'est collectée, stockée ou transmise. Votre confidentialité et celle de vos patients est totalement préservée.'
    }
  ]

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="section-padding bg-slate-50">
      <div className="container-max">
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Tout ce que vous devez savoir sur EMDR Plus
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Les réponses aux questions les plus fréquentes de nos utilisateurs
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="mb-4"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full bg-white rounded-lg p-6 text-left hover:shadow-md transition-shadow duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500"
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </h3>
                  {openIndex === index ? (
                    <FaChevronUp className="w-5 h-5 text-primary-600 flex-shrink-0" />
                  ) : (
                    <FaChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
                  )}
                </div>
              </button>
              
              <motion.div
                initial={false}
                animate={{
                  height: openIndex === index ? 'auto' : 0,
                  opacity: openIndex === index ? 1 : 0
                }}
                transition={{ duration: 0.3 }}
                className="overflow-hidden"
              >
                <div className="bg-white px-6 pb-6 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQSection 